import { t } from "ttag";

export const INVALID_AMOUNT_ERROR = t`Enter your margin first.`
